import type { Order } from "@graphql/generated/types";
import type { IAdyenPaymentMethodStrategy } from "@interfaces/payment-method/AdyenPaymentMethodStrategy";
import type { PaymentValues } from "@lib/utils/checkoutHelper";

export class AdyenResolver {
    private strategies: Map<string, IAdyenPaymentMethodStrategy>;

    constructor(strategies: Map<string, IAdyenPaymentMethodStrategy>) {
        this.strategies = strategies;
    }

    resolve(order: Order): PaymentValues {
        if (!order?.paymentInfo?.payments) return null;

        const advancedFlowStrategyResult = this.strategies.get("advancedFlow")?.resolve(order);

        if (advancedFlowStrategyResult?.paymentSystem) {
            return advancedFlowStrategyResult;
        }

        const deferredPaymentStrategyResult = this.strategies
            .get("deferredPayment")
            ?.resolve(order);

        if (deferredPaymentStrategyResult?.paymentSystem) {
            return deferredPaymentStrategyResult;
        }

        //return initial values
        return {
            paymentSystem: null,
            paymentSystemIcon: null,
            paymentReference: null,
            paymentDateOfExpiry: null,
        };
    }
}
